const Commands = {
  duplicate: 'nv:duplicate',
  copy: 'nv:copy',
  paste: 'core:paste'
};

const clipboardStorage = {
  clipboardKey: 'gjs.clipboard',
  setItem(value) {
    localStorage.setItem(this.clipboardKey, JSON.stringify(value));
  },
  getItem() {
    const value = localStorage.getItem(this.clipboardKey);
    return JSON.parse(value);
  }
};

const addButtonToComponentToolbar = (component, icon, command, targetId, title) => {
  const {attributes} = component;
  const {copyable} = attributes;
  if (!copyable) {
    console.warn('Component cannot be copied');
    return;
  }
  const defaultToolbar = component.get('toolbar');
  const commandExists = defaultToolbar.some(item => item.command === command);
  if (commandExists) {
    console.log('Button already exists');
    return;
  }

  const btnAttrs = {class: icon};
  if (title) {
    btnAttrs.title = title;
  }

  const tmpToolbar = [];
  [...defaultToolbar].map(item => {
    if (targetId === item.command) {
      tmpToolbar.push({attributes: btnAttrs, command: command});
    }
    tmpToolbar.push(item);
  });

  component.set({toolbar: tmpToolbar});
};

const removeButtonFromComponentToolbar = (component, commandId) => {
  if (!component) return;
  const toolbar = component.get('toolbar');
  if (!Array.isArray(toolbar)) return;

  const updated = toolbar.filter(item => item.command !== commandId);
  if (updated.length === toolbar.length) return;

  component.set({toolbar: updated});
};

const addButtons = (editor) => {
  editor.on('component:selected', () => {
    const component = editor.getSelected();
    removeButtonFromComponentToolbar(component, 'tlb-clone');
    addButtonToComponentToolbar(component, 'fa fa-copy', Commands.copy, 'tlb-delete', 'Copy');
    addButtonToComponentToolbar(component, 'fa fa-paste', Commands.paste, 'tlb-delete', 'Paste');
    addButtonToComponentToolbar(component, 'fa fa-clone', Commands.duplicate, 'tlb-delete', 'Duplicate');
  });
};

const addKeymaps = (editor) => {
  const Keymaps = {
    duplicate: {
      id: Commands.duplicate,
      keys: '⌘+d, ctrl+d',
      handler: Commands.duplicate
    },
    copy: {
      id: Commands.copy,
      keys: '⌘+c, ctrl+c',
      handler: Commands.copy
    },
    paste: {
      id: Commands.paste,
      keys: '⌘+v, ctrl+v',
      handler: Commands.paste
    },
  };

  for (const [, config] of Object.entries(Keymaps)) {
    const {id, keys, handler} = config;
    editor.Keymaps.add(id, keys, handler);
  }
};

const registerCommands = (editor) => {
  const commands = editor.Commands;

  commands.add(Commands.copy, (editor) => {
    const selected = [...editor.getSelectedAll()];
    let filteredSelected = selected.filter(item => item.attributes.copyable === true);
    if (filteredSelected.length) {
      clipboardStorage.setItem(filteredSelected);
    }
  });

  commands.add(Commands.paste, editor => {
    const selected = editor.getSelected();
    const components = clipboardStorage.getItem();
    if (selected && Array.isArray(components)) {
      editor.getSelected().parent().append(components.pop(), {at: selected.index() + 1});
    } else {
      editor.addComponents(components);
    }
  });

  commands.add(Commands.duplicate, editor => {
    const selected = editor.getSelected();
    if (selected) {
      const cloned = selected.clone();
      selected.parent().append(cloned, {at: selected.index() + 1});
    }
  });
}

export default (editor) => {
  registerCommands(editor);
  addButtons(editor);
  addKeymaps(editor);
};
